export enum KnowledgeHubRecordType {
  PRIORITY = 'PRIORITY',
  OBJECTION = 'OBJECTION',
  QUESTION = 'QUESTION',
  HIDDEN_CONTEXT = 'HIDDEN_CONTEXT',
}
